const LedvibeInteractions = (() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const getSelectedOptions = (scope) => {
    const values = [];

    scope.querySelectorAll('input[type="radio"]:checked, select').forEach((control) => {
      const value = control.tagName === 'SELECT'
        ? control.options[control.selectedIndex]?.textContent
        : control.value;

      if (value && !values.includes(value.trim())) values.push(value.trim());
    });

    return values.join(' · ');
  };

  const initializeReveal = (root) => {
    const targets = root.querySelectorAll([
      '.lv-catalog-preview__header',
      '.lv-catalog-preview__card',
      '.lv-product-story > .lv-story-shell > *',
      '.lv-home-light__hero',
      '.lv-home-light__product',
      '.lv-store-framework__section',
      '.lv-cart-assurance__shell'
    ].join(','));

    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      targets.forEach((target) => target.classList.add('is-revealed'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    targets.forEach((target, index) => {
      if (target.dataset.lvRevealInitialized === 'true') return;
      target.dataset.lvRevealInitialized = 'true';
      target.classList.add('lv-reveal');
      target.style.setProperty('--lv-reveal-delay', `${Math.min(index % 6, 5) * 45}ms`);
      observer.observe(target);
    });
  };

  const initializeScrollTools = () => {
    if (document.querySelector('[data-lv-scroll-progress]')) return;

    const updatePreviewMode = () => {
      document.body.classList.toggle('lv-shopify-preview', Boolean(document.getElementById('PBarNextFrame')));
    };

    updatePreviewMode();
    window.setTimeout(updatePreviewMode, 800);

    const progress = document.createElement('div');
    progress.className = 'lv-scroll-progress';
    progress.dataset.lvScrollProgress = '';
    progress.setAttribute('aria-hidden', 'true');

    const backToTop = document.createElement('button');
    backToTop.type = 'button';
    backToTop.className = 'lv-back-to-top';
    backToTop.dataset.lvBackToTop = '';
    backToTop.setAttribute('aria-label', 'Back to top');
    backToTop.innerHTML = '<span aria-hidden="true">↑</span>';
    backToTop.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    });

    document.body.append(progress, backToTop);

    let ticking = false;
    const update = () => {
      const scrollable = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
      const ratio = Math.min(Math.max(window.scrollY / scrollable, 0), 1);
      progress.style.setProperty('--lv-scroll-progress', ratio);
      backToTop.classList.toggle('is-visible', window.scrollY > 720);
      document.body.classList.toggle('lv-page-scrolled', window.scrollY > 16);
      ticking = false;
    };

    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });

    update();
  };

  const initializeProductDock = () => {
    const main = document.querySelector('main[data-template^="product"]');
    if (!main || document.querySelector('[data-lv-product-dock]')) return;

    const productInformation = main.querySelector('[id^="ProductInformation-"]') || main.querySelector('product-information') || main;
    const sectionAnchor = productInformation.closest('.shopify-section') || productInformation;
    const title = productInformation.querySelector('h1')?.textContent.trim();
    const primaryButton = productInformation.querySelector('button[name="add"], button[type="submit"]');

    if (!title || !primaryButton) return;

    const dock = document.createElement('aside');
    dock.className = 'lv-product-dock';
    dock.dataset.lvProductDock = '';
    dock.setAttribute('aria-label', 'Selected product options');
    dock.innerHTML = `
      <div class="lv-product-dock__summary">
        <strong></strong>
        <span data-lv-product-dock-options></span>
      </div>
      <a href="#${sectionAnchor.id || 'MainContent'}" data-lv-product-dock-action>Review options</a>
    `;

    dock.querySelector('strong').textContent = title;
    const optionText = dock.querySelector('[data-lv-product-dock-options]');
    const action = dock.querySelector('[data-lv-product-dock-action]');

    const updateDock = () => {
      optionText.textContent = getSelectedOptions(productInformation) || 'Choose the exact configuration';
      action.textContent = primaryButton.disabled ? 'Review options' : 'Choose options';
    };

    productInformation.addEventListener('change', updateDock);
    new MutationObserver(updateDock).observe(primaryButton, { attributes: true, childList: true, subtree: true });

    const observer = new IntersectionObserver(([entry]) => {
      dock.classList.toggle('is-visible', !entry.isIntersecting && window.scrollY > 260);
    }, { threshold: 0.05 });

    observer.observe(primaryButton);
    document.body.appendChild(dock);
    document.body.classList.add('lv-has-product-dock');
    updateDock();
  };

  const initialize = (root = document) => {
    initializeReveal(root);
    initializeScrollTools();
    initializeProductDock();
  };

  return { initialize };
})();

LedvibeInteractions.initialize();
document.addEventListener('shopify:section:load', (event) => LedvibeInteractions.initialize(event.target));
